import { useRef, useEffect, useState } from 'react'
import { Helmet } from "react-helmet";
import moment from 'moment-timezone';
import { Box, Grid, Container, Tab, Tabs, Toolbar, Typography, useTheme } from "@mui/material";
import { tokens } from "../../../theme";
import ColumnChartGiveaway from "../../../components/chart/ColumnChartGiveaway";
import db from "../../../firebase-config";
import useCheckToken from '../../../hooks/useCheckToken';
import useExchangeToken from "../../../hooks/useExchangeToken";
import { useParams } from 'react-router-dom'
import { keyframes } from '@emotion/react';



const GiveawayRolloutPage2 = () => {
    const { bu, plant, factory, line } = useParams();
    const exchangeToken = useExchangeToken();
    const theme = useTheme();
    const colors = tokens(theme.palette.mode);
    const now = moment().tz('Asia/Bangkok');
    const hourAgo = moment().tz('Asia/Bangkok').subtract(1, 'hours');
    const [isTokenExchanged, setIsTokenExchanged] = useState(false);
    const [error, setError] = useState(null);

    const [giveaway_rollout, setgiveaway_rollout] = useState([]);
    const [giveaway_rollout_store, setgiveaway_rollout_store] = useState([]);
    const [chart_giveaway, setChart_giveaway] = useState([]);
    //const [giveaway_taglist, setgiveaway_taglist] = useState([]);

    // const tagProvider = plant === '4117' ? 'Further' : plant === '4116' ? 'MES_Minburi' : plant === 'B425' ? 'MES_VN' : 'Further';
    // const tagFactory = factory === 'FPP2' || factory === 'PlantB' || factory === 'FPP1' || factory === 'FPP3' ? '00000000000000' : factory;
    // const tagCountry = plant === 'B425' ? 'Vietnam' : 'Thailand';
    // const tagPrefix = `${tagProvider}.${plant}.${tagFactory}.${tagCountry}.Dashboard.GiveAway.${line}`;


    useCheckToken();

    useEffect(() => {
        const fetchInitialTokenAndData = async () => {
            try {
                const token = await exchangeToken();
                if (token) {
                    setIsTokenExchanged(true);
                }
            } catch (err) {
                console.error("Error exchanging token:", err);
                setError("Failed to exchange token");
            }
        };

        fetchInitialTokenAndData();
    }, [exchangeToken]);

    const formatNum = (val, maximumFractionDigits = 2, fallback = '-') => {
        if (val === undefined || val === null) return fallback;
        if (typeof val === 'string' && val.trim().toUpperCase() === 'NA') return 'NA';
        const n = Number(val);
        if (Number.isNaN(n)) return fallback;
        if (n <= 0) return '0';
        return n.toLocaleString(undefined, { maximumFractionDigits: maximumFractionDigits });
    };


    useEffect(() => {
        const docId = `${plant === 'B425' ? 'Vietnam' : 'Thailand'}${plant}${factory === 'FPP2' || factory === 'PlantB' || factory === 'FPP1' || factory === 'FPP3' ? '00000000000000' : factory}${line}Giveaway_V2`;
        const docRef = db.collection('prod_mes_ignition_giveaway_v2').doc(docId);

        const subscribe = docRef.onSnapshot((docSnapshot) => {
            if (docSnapshot.exists) {
                setgiveaway_rollout([{ ...docSnapshot.data(), id: docSnapshot.id }][0]);
                sessionStorage.setItem("GiveawayRollout", JSON.stringify([{ ...docSnapshot.data(), id: docSnapshot.id }][0]));
            } else {
                console.log('No such document!');
                setgiveaway_rollout([]);
            }
        });

        const subscriberChartGiveaway = db
            .collection("prod_mes_ignition_giveaway_v2_5mtf")
            .onSnapshot((querySnapshot) => {
                const giveawayData = querySnapshot.docs.map(doc => ({
                    ...doc.data(),
                    id: doc.id,
                }));
                const filteredDocs = giveawayData.filter(doc =>
                    doc.id.includes(plant) && doc.id.includes(line)
                );
                setChart_giveaway(filteredDocs);
                const recentData = filteredDocs.filter(item =>
                    moment(item.TIMESTAMP).tz('Asia/Bangkok').isBetween(hourAgo, now, null, '[)')
                );

                const formatted = recentData.map(item => ({
                    time: moment(item.TIMESTAMP).tz('Asia/Bangkok').format('HH:mm'),
                    value: item.GIVEAWAY_PERCENT == null ? 0 : parseFloat(item.GIVEAWAY_PERCENT).toFixed(2),
                }));

                const timeValueMap = new Map(formatted.map(d => [d.time, d.value]));
                const uniqueTimes = [...new Set(formatted.map(d => d.time))].sort();

                while (uniqueTimes.length < 12) {
                    const oldestTime = uniqueTimes[0];
                    const prev = moment(oldestTime, 'HH:mm').subtract(5, 'minutes').format('HH:mm');
                    uniqueTimes.unshift(prev);
                    timeValueMap.set(prev, 0);
                }
            });

        // const subscriberGiveawayTaglist = db
        //     .collection("prod_mes_ignition_giveaway_v2_tag_list")
        //     .where("TAG_NAME", "in", [
        //         `${tagPrefix}.MTH_Status`,
        //         `${tagPrefix}.CW_Status`,
        //         `${tagPrefix}.Counter_Status`,
        //         `${tagPrefix}.L5_PG_ALIVE_GA`,
        //     ])
        //     .onSnapshot((querySnapshot) => {
        //         const giveawayData = querySnapshot.docs.map(doc => ({
        //             ...doc.data(),
        //             id: doc.id,
        //         }));

        //         setgiveaway_taglist(giveawayData);
        //     });
        return () => {
            subscribe();
            subscriberChartGiveaway();
            //subscriberGiveawayTaglist();
        };
    }, []);


    useEffect(() => {
        const stored = sessionStorage.getItem("GiveawayRollout");
        if (stored) setgiveaway_rollout_store(JSON.parse(stored));
    }, []);

    // const findMachine = (key) => (giveaway_taglist || []).find((a) => (a?.TAG_NAME || "").includes(key)) || null;
    // const multiheadStatus = findMachine(`${tagPrefix}.MTH_Status`);
    // const checkWeightStatus = findMachine(`${tagPrefix}.CW_Status`);
    // const AICameraStatus = findMachine(`${tagPrefix}.Counter_Status`);
    // const aiAliveTag = findMachine(`${tagPrefix}.L5_PG_ALIVE_GA`);

    const FORMAT = 'YYYY-MM-DD HH:mm:ss';
    const SLOT_COUNT = 12;
    const INTERVAL = 5;


    let recentData = chart_giveaway.filter(item => {
        const m = moment.tz(item.TIMESTAMP, FORMAT, 'Asia/Bangkok');
        return m.isValid() && m.isBetween(hourAgo, now, null, '[)');
    });
    const formatted = recentData.map(item => {
        const m = moment.tz(item.TIMESTAMP, FORMAT, 'Asia/Bangkok');
        return {
            time: m.format('HH:mm'),
            value: item.GIVEAWAY_PERCENT == null ? 0 : Number(item.GIVEAWAY_PERCENT).toFixed(2)
        };
    });

    const timeValueMap = new Map(formatted.map(d => [d.time, d.value]));
    const uniqueTimes = [...new Set(formatted.map(d => d.time))].sort();

    if (uniqueTimes.length > 0) {
        while (uniqueTimes.length < SLOT_COUNT) {
            const oldest = uniqueTimes[0];  
            const prev = moment(oldest, 'HH:mm').subtract(INTERVAL, 'minutes').format('HH:mm');
            uniqueTimes.unshift(prev);
            if (!timeValueMap.has(prev)) timeValueMap.set(prev, 0);
        }
    }

    const finalTimes = uniqueTimes.slice(-SLOT_COUNT);

    const sliced_show_time = finalTimes;
    const sliced_show_value = finalTimes.map(t => Number(timeValueMap.get(t) ?? 0));

    const bestPracticeDisplay = (() => {
        // fallback to store or live rollout (mirrors your logic but safe)
        const source = giveaway_rollout?.WARNING === undefined
            ? giveaway_rollout_store
            : giveaway_rollout;
        if (!source) return '-';
        if (source.WARNING === 'ไม่ตรงแผนผลิต') return '-';
        return formatNum(source.BEST_PRACTICE, 2, '-');
    })();

    const actualDisplay = (() => {
        const source = giveaway_rollout?.WARNING === undefined
            ? giveaway_rollout_store
            : giveaway_rollout;
        if (!source) return '-';
        if (source.WARNING === 'ไม่ตรงแผนผลิต') return '-';
        if (source.AVG_GIVEAWAY === 'NA') return 'NA';
        return formatNum(source.AVG_GIVEAWAY, 2, '0');
    })();

    return (
        <>
            <Helmet>
                <title>Giveaway Rollout Page2 | MES</title>
            </Helmet>
            <Grid item xs={12} sm={12} style={{ backgroundColor: colors.neutral['black'], paddingTop: 0, paddingLeft: 50 }}>
                <Grid item xs={12} textAlign="left" style={{ paddingRight: 20 }}>
                    <Typography style={{ color: colors.neutral['white'], fontSize: 60, fontWeight: 'bold' }} >
                        Realtime Giveaway (%)
                    </Typography>
                </Grid>
                <Grid item xs={12} textAlign="center" style={{ paddingTop: 0 }}>
                    <Grid container rowSpacing={0} columnSpacing={{ xs: 0, sm: 0, md: 0 }}>
                        <Grid item xs={8} >
                            <Grid item xs={12} md={12} lg={12} xl={12} textAlign="center" style={{ position: "relative", height: '60vh' }}>
                                <Grid item xs={12} md={12} lg={12} xl={12} textAlign="center" style={{ position: "relative", height: '60vh' }}>
                                    <ColumnChartGiveaway
                                        value={sliced_show_value}
                                        time={sliced_show_time}
                                        target={giveaway_rollout?.WARNING == undefined ? 0 : giveaway_rollout?.WARNING == 'ไม่ตรงแผนผลิต' ? 0 : giveaway_rollout?.BEST_PRACTICE == 'NA' ? 0 : giveaway_rollout?.BEST_PRACTICE <= 0 ? 0 : Math.round(giveaway_rollout?.BEST_PRACTICE)}
                                        target_giveaway={giveaway_rollout?.WARNING == undefined ? 0 : giveaway_rollout?.WARNING == 'ไม่ตรงแผนผลิต' ? 0 : giveaway_rollout?.AVG_GIVEAWAY == 'NA' ? 0 : giveaway_rollout?.AVG_GIVEAWAY <= 0 ? 0 : Math.round(giveaway_rollout?.AVG_GIVEAWAY)}
                                        height='100%'
                                        fontsize={24}
                                    />
                                </Grid>
                            </Grid>
                        </Grid>

                        <Grid item xs={4} style={{ paddingTop: 30 }}>
                            <Grid item xs={12} md={12} lg={12} xl={12} textAlign="center" >
                                <Typography style={{ color: colors.neutral['white'], fontSize: 42, fontWeight: 'bold' }} >
                                    Best Practice
                                </Typography>
                            </Grid>
                            <Grid item xs={12} md={12} lg={12} xl={12} textAlign="center" >
                                <Typography style={{ color: '#4AC6B1', fontSize: 54, fontWeight: 'bold', lineHeight: "4vh" }} >
                                {bestPracticeDisplay}%
                                </Typography>
                            </Grid>
                            <Grid item xs={12} md={12} lg={12} xl={12} style={{ paddingTop: 50 }} >
                                <Typography style={{ color: colors.neutral['white'], fontSize: 42, fontWeight: 'bold' }} >
                                    Actual
                                </Typography>
                            </Grid>
                            <Grid item xs={12} md={12} lg={12} xl={12} textAlign="center" >
                                <Typography style={{ color: '#4AC6B1', fontSize: 54, fontWeight: 'bold', lineHeight: "4vh" }} >
                                {actualDisplay}%
                                </Typography>
                            </Grid>
                        </Grid>
                    </Grid>
                </Grid>
            </Grid>
        </>
    )
}

export default GiveawayRolloutPage2
